/// <amd-module name="VSS/Redux/Modules/Shortcuts/ShortcutsModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { shortcutsSaga } from "./ShortcutsSaga";

/**
 * For registering redux friendly shortcuts with the IVssKeyboardShortcutService. See SprintCapacityPivotModule
 * for an example. These shortcuts will dispatch the redux action when pressed.
 */
export const ShortcutsModule: ISagaModule<any> = {
    id: "shortcuts-module",
    sagas: [shortcutsSaga as any]
};
